import moduleInit from '@utilities/module-init';
import { body } from '@utilities/dom-elements';

const COUNTRY_SELECT = '[js-hook-country-selector]';
const LANGUAGE_SELECT = '[js-hook-language-selector]';
const COUNTRY_SELECTION_SUBMIT = '[js-hook-country-submit]';
const CUSTOM_SELECT = '[js-hook-custom-select-box]';
const CUSTOM_SELECT_CLASS = 'c-select--custom';
const CUSTOM_COUNTRY_MODAL_OPEN = 'is--country-modal-open';
const MODAL_COUNTRY_GATEWAY = '.footer__language-selector-select-item';
const SELECT_LABEL_CLASS = '.select__label';
const FORM_ITEM_CLASS = '.form__item';
const FORM_ITEM_DISABLED_CLASS = 'form__item--disabled';
const OPTION_ELEMENT = 'option';
const CSB_LIST_CLASS = '.csb__list';

class EnhancedCountrySelector {
  constructor(element) {
    this.element = element;
    this.countrySelectbox = this.element.querySelector(COUNTRY_SELECT);
    this.languageSelectbox = this.element.querySelector(LANGUAGE_SELECT);
    this.languageSelectboxFormItem = this.languageSelectbox.closest(FORM_ITEM_CLASS);
    this.defaultLanguageOption = this.languageSelectbox.querySelector(OPTION_ELEMENT);
    this.submit = this.element.querySelector(COUNTRY_SELECTION_SUBMIT);
    this.modalCountryGateway = document.querySelector(MODAL_COUNTRY_GATEWAY);

    this.cookieData = {
      country: JSON.parse(this.submit.dataset.cookieObject)[0],
      language: JSON.parse(this.submit.dataset.cookieObject)[1]
    };

    this.bindEvents();
  }

  bindEvents() {
    this.countrySelectbox.addEventListener("change", () => this.onCountryChange());
    this.languageSelectbox.addEventListener("change", () => this.onLanguageChange());

    if (this.modalCountryGateway) {
      this.modalCountryGateway.addEventListener("click", () => body.classList.add(CUSTOM_COUNTRY_MODAL_OPEN));
    }
  }

  onCountryChange() {
    // Create language dropdown
    const {value} = this.countrySelectbox;
    const selectedOption = this.countrySelectbox.querySelector(`option[value=${value}]`);
    const selectedOptionLangData = selectedOption.dataset.languages;
    const languages = JSON.parse(selectedOptionLangData);

    this.saveCookieData(this.countrySelectbox.value, selectedOption.dataset.defaultLanguage);

    // Create language options
    let options = '';
    languages.forEach(lang => {
      const selectedLanguage = languages.find(obj => obj.value === lang.value);
      options += `<option value="${lang.value}" data-url="${lang.redirectTarget}" data-id="${lang.value}" data-switch-url="${selectedLanguage.switchUrl}">${lang.displayName}</option>`;
    })

    // Set language dropdown
    this.isSingleLanguageOption = languages.length === 1;
    this.languageSelectbox.innerHTML = options;
    this.languageSelectbox.prepend(this.defaultLanguageOption);
    this.languageSelectbox.value = this.isSingleLanguageOption ? languages[0].value : '';
    this.languageSelectbox.disabled = this.isSingleLanguageOption;

    this.languageSelectboxFormItem.classList[this.isSingleLanguageOption ? 'add' : 'remove'](FORM_ITEM_DISABLED_CLASS);

    // Reinit custom dropdown for new languages
    if (this.element.querySelector(CSB_LIST_CLASS)) {
      // Reset
      const wrapper = this.languageSelectbox.closest(CUSTOM_SELECT);
      wrapper.classList.remove(CUSTOM_SELECT_CLASS)
      wrapper.querySelector(`${SELECT_LABEL_CLASS} span:not(:first-child)`).remove();
      wrapper.querySelector(CSB_LIST_CLASS).remove();

      // Reinit
      moduleInit.async(`${CUSTOM_SELECT}:not(.${CUSTOM_SELECT_CLASS})`, () =>
          import(/* webpackChunkName: "js/CustomSelectBox" */ '@components/custom-select-box'),
        {
          force: true
        }
      );
    }

    // Update submit button with default url for this country
    this.submit.href = this.isSingleLanguageOption ? languages[0].switchUrl : '';
    if (this.isSingleLanguageOption) {
      this.submit.removeAttribute('disabled');
    } else {
      this.submit.setAttribute('disabled', 'disabled');
    }

  }

  onLanguageChange() {
    this.saveCookieData(this.countrySelectbox.value, this.languageSelectbox.value);

    // Update submit button with default url for this country
    const {value} = this.languageSelectbox;
    const selectedOption = this.languageSelectbox.querySelector(`option[value=${value}]`);

    this.submit.href = selectedOption.dataset.switchUrl;
    this.submit.removeAttribute('disabled', 'false');
  }

  // Save locale data to submit button
  // Submit is hooked to save cookie data
  saveCookieData(country, language) {
    this.cookieData.country.value = country;
    this.cookieData.language.value = language;

    this.submit.dataset.cookieObject = JSON.stringify([
      this.cookieData.country,
      this.cookieData.language
    ]);
  }
}

export default EnhancedCountrySelector;
